import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

ClassNameGenerator.configure((componentName) => componentName.replace('Mui', 'V5')); // load as early as possible this code in a js file
import '../../utils/MuiClassNameSetup';
 
import React from 'react';
import { renderReact } from '../../fragmentHelper/renderReactCustom';
import eshopHeaderModule from '@rakutenfrance/eshop-header';
import { GetServerSidePropsHypernovaWatchContext } from '../../types';
import { PagePropsType, regroupModuleReducers, getServerSidePropsLoader } from '@rakutenfrance/redux-apollo-helper';
import { ReduxApolloFragmentWrapperChildren } from '../../fragmentHelper/Wrapper';
import { configService as configurationService } from '@rakutenfrance/config-service';
import { tolgeeModule, getLanguageFromRequest } from '@rakutenfrance/tolgee-provider';

const { EshopHeaderContainer } = eshopHeaderModule.containers;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const modules = [eshopHeaderModule, tolgeeModule];
const reducers = regroupModuleReducers(modules);

const WrappedEshopHeader: React.FC<PagePropsType> = ({ initialApolloState, initialReduxState, moduleName }) => (
  <ReduxApolloFragmentWrapperChildren
    initialApolloState={initialApolloState}
    initialReduxState={initialReduxState}
    moduleName={moduleName}
    reducers={reducers}
  >
    <EshopHeaderContainer />
  </ReduxApolloFragmentWrapperChildren>
);

export const renderFunction = renderReact('EshopHeader', WrappedEshopHeader);

export const serverCanCache = true;

 
export const getServerSideProps = async (watchContext: GetServerSidePropsHypernovaWatchContext) => {
  const baseUrl = null;
  // @ts-expect-error - Type mismatch between Hypernova's RequestType and tolgee-provider's expected RequestType
  const language = getLanguageFromRequest(watchContext.req)
  const gatewayUrl =
    language === 'fr-FR'
      ? configurationService.get().backendVisUrl
      : configurationService.get().translationProxyBackendVisUrl
  const wsBaseUrl = gatewayUrl;
  const preloadedConfig = {
    EshopHeader: {
      eshopSellerLogin: watchContext.jobData?.eshopSellerLogin !== undefined ? watchContext.jobData.eshopSellerLogin : null,
      wsBaseUrl,
      kw: watchContext.jobData?.kw !== undefined ? watchContext.jobData.kw : '',
    },
  };
  const graphQlVariables = {};
  const graphQlQuery = '';
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { initialReduxState, initialApolloState } = await getServerSidePropsLoader(
    watchContext,
    modules,
    baseUrl,
    preloadedConfig,
    graphQlQuery,
    graphQlVariables
  );

  return {
    props: {
      initialReduxState,
      initialApolloState,
    },
  };
};
